const e=e=>e.replace(/(.)([A-Z][a-z]+)/,"$1-$2").replace(/([a-z0-9])([A-Z])/,"$1-$2").toLowerCase();export{e as normalizeStylePropName};